import { NgModule } from '@angular/core';
import { LlDecoratedArrowDirective } from './ll-decorated-arrow.directive';
import { LlDecoratedPanelDirective } from './ll-decorated-panel.directive';
import { LlDecoratedTabDirective } from './ll-decorated-tab.directive';

@NgModule({
    declarations: [
        LlDecoratedArrowDirective,
        LlDecoratedPanelDirective,
        LlDecoratedTabDirective,
    ],
    exports: [
        LlDecoratedArrowDirective,
        LlDecoratedPanelDirective,
        LlDecoratedTabDirective
    ]
})
export class LlTabsDecoratedModule {}